// ============================================
// TAREAS.JS — Gestión de tareas y asignaciones
// ============================================
import { useBorradorCampos, AvisoRescate } from './utils/borradorFormulario';
import React, { useState, useEffect, useMemo } from 'react';
import { API_BASE } from './config/api';

const PP = "'Poppins', sans-serif";
const COLOR_PRINCIPAL = '#5c9adb';
const COLOR_OSCURO = '#2f5f9e';
const COLOR_FONDO = '#f3f4f4';
const COLOR_GRIS = '#4e5357';
const COLOR_GRIS_CLARO = '#8a8f95';
const COLOR_ALTA = '#e05c5c';
const COLOR_MEDIA = '#dcde74';
const COLOR_BAJA = '#5cd4b0';

const KEY_TAREAS = 'beep_tareas';
const KEY_USUARIOS = 'beep_usuarios';
const KEY_PROYECTOS = 'beep_proyectos';

const TIPO_PROYECTO_INFO = {
  instalacion:    { label: 'Instalación',         icono: '🏗️' },
  servicio:       { label: 'Servicio correctivo', icono: '🔧' },
  levantamiento:  { label: 'Levantamiento',       icono: '📏' },
  mantenimiento:  { label: 'Mantenimiento',       icono: '🔩' },
  soporte_ti:     { label: 'Soporte TI',          icono: '💻' },
  monitoreo:      { label: 'Monitoreo',           icono: '👁️' },
  otro:           { label: 'Otro',                icono: '📁' },
};
const SUBTIPOS = ['cctv', 'redes', 'alarmas', 'control_acceso', 'computo', 'general'];

const ROL_INFO = {
  direccion:      { label: 'Dirección',      color: '#2f5f9e' },
  administracion: { label: 'Administración', color: '#5c9adb' },
  supervisor:     { label: 'Supervisor',     color: '#5cd4b0' },
  comercial:      { label: 'Comercial',      color: '#f4a261' },
  marketing:      { label: 'Marketing',      color: '#dcde74' },
  tecnico:        { label: 'Técnico',        color: '#9b59b6' },
  almacen:        { label: 'Almacén',        color: '#e05c5c' },
};

const PRIORIDAD_INFO = {
  alta:  { label: 'Alta',  color: COLOR_ALTA,  peso: 3 },
  media: { label: 'Media', color: COLOR_MEDIA, peso: 2 },
  baja:  { label: 'Baja',  color: COLOR_BAJA,  peso: 1 },
};

const ESTADO_INFO = {
  pendiente:   { label: 'Pendiente',   color: '#8a8f95', bg: '#eef0f3' },
  en_proceso:  { label: 'En proceso',  color: '#2f5f9e', bg: '#eaf2fb' },
  completada:  { label: 'Completada',  color: '#1D9E75', bg: '#e8faf5' },
  cancelada:   { label: 'Cancelada',   color: '#9a8300', bg: '#fffbe6' },
  convertida_proyecto: { label: 'Convertida en proyecto', color: '#5c9adb', bg: '#eaf2fb' },
};

const TIPO_INFO = {
  normal:        { label: 'Normal',        icono: '✓' },
  ciclica:       { label: 'Cíclica',       icono: '🔄' },
  proyecto:      { label: 'Proyecto',      icono: '📁' },
  requerimiento: { label: 'Requerimiento', icono: '📋' },
};

const DIAS_SEMANA = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes'];

function TAREAS_DEMO() {
  const ahora = Date.now();
  return [
    {
      id: 1, folio: 'TAR-2026-001',
      titulo: 'Entregar reporte de facturación',
      descripcion: 'Reporte quincenal de facturas emitidas y pendientes',
      asignadoA: 3, asignadoPor: 1, rol: 'administracion',
      prioridad: 'alta', estado: 'pendiente',
      tipo: 'ciclica', ciclica: true, frecuencia: 'quincenal', diaSemana: null,
      fechaVencimiento: new Date(ahora).toISOString(), hora: '10:00',
      fechaCreacion: new Date(ahora - 5 * 86400000).toISOString(),
      fechaCompletada: null,
      notificarA: [1, 2], etiquetas: [], notas: [],
      origen: 'manual', origenId: null,
    },
    {
      id: 2, folio: 'TAR-2026-002',
      titulo: 'Preparar kits para servicios del jueves',
      descripcion: 'Revisar órdenes y preparar material',
      asignadoA: 7, asignadoPor: 4, rol: 'almacen',
      prioridad: 'alta', estado: 'en_proceso',
      tipo: 'normal', ciclica: false,
      fechaVencimiento: new Date(ahora + 86400000).toISOString(), hora: '08:00',
      fechaCreacion: new Date(ahora - 2 * 86400000).toISOString(),
      fechaCompletada: null,
      notificarA: [4], etiquetas: [], notas: [],
      origen: 'manual', origenId: null,
    },
    {
      id: 3, folio: 'TAR-2026-003',
      titulo: 'Cotización sistema CCTV Bodegas Alianza',
      descripcion: 'Generar cotización para 16 cámaras IP',
      asignadoA: 1, asignadoPor: 1, rol: 'direccion',
      prioridad: 'media', estado: 'pendiente',
      tipo: 'normal', ciclica: false,
      fechaVencimiento: new Date(ahora + 2 * 86400000).toISOString(), hora: null,
      fechaCreacion: new Date(ahora - 86400000).toISOString(),
      fechaCompletada: null,
      notificarA: [], etiquetas: [], notas: [],
      origen: 'manual', origenId: null,
    },
    {
      id: 4, folio: 'TAR-2026-004',
      titulo: 'Publicar contenido redes sociales',
      descripcion: 'Post semanal para Instagram y Facebook',
      asignadoA: 5, asignadoPor: 1, rol: 'marketing',
      prioridad: 'media', estado: 'pendiente',
      tipo: 'ciclica', ciclica: true, frecuencia: 'semanal', diaSemana: 'lunes',
      fechaVencimiento: new Date(ahora + 3 * 86400000).toISOString(), hora: '09:00',
      fechaCreacion: new Date(ahora - 7 * 86400000).toISOString(),
      fechaCompletada: null,
      notificarA: [1], etiquetas: [], notas: [],
      origen: 'manual', origenId: null,
    },
  ];
}

function cargarTareas() {
  try {
    const raw = localStorage.getItem(KEY_TAREAS);
    if (raw) return JSON.parse(raw);
  } catch {}
  const seed = TAREAS_DEMO();
  try { localStorage.setItem(KEY_TAREAS, JSON.stringify(seed)); } catch {}
  return seed;
}

function guardarTareasLS(arr) {
  try { localStorage.setItem(KEY_TAREAS, JSON.stringify(arr)); } catch {}
}

function cargarUsuariosLS() {
  try {
    const raw = localStorage.getItem(KEY_USUARIOS);
    if (raw) return JSON.parse(raw);
  } catch {}
  return [];
}

function normalizarRol(rol) {
  if (!rol) return 'direccion';
  const r = String(rol).toLowerCase();
  if (r.includes('direcc')) return 'direccion';
  if (r.includes('admin')) return 'administracion';
  if (r.includes('superv')) return 'supervisor';
  if (r.includes('comerc')) return 'comercial';
  if (r.includes('market')) return 'marketing';
  if (r.includes('técnic') || r.includes('tecnic')) return 'tecnico';
  if (r.includes('almac')) return 'almacen';
  return 'direccion';
}

function iniciales(nombre) {
  return (nombre || '?').split(' ').filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
}

function siguienteFolio(tareas) {
  const año = new Date().getFullYear();
  const n = tareas.length + 1;
  return `TAR-${año}-${String(n).padStart(3, '0')}`;
}

function fechaCorta(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' });
  } catch { return '—'; }
}

function diasHasta(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const hoy = new Date();
  d.setHours(0, 0, 0, 0); hoy.setHours(0, 0, 0, 0);
  return Math.round((d - hoy) / 86400000);
}

function colorVencimiento(iso) {
  const d = diasHasta(iso);
  if (d === null) return COLOR_GRIS_CLARO;
  if (d <= 0) return COLOR_ALTA;
  if (d <= 2) return '#e8a44a';
  return '#1D9E75';
}

function textoVencimiento(iso) {
  const d = diasHasta(iso);
  if (d === null) return 'Sin fecha';
  if (d < 0) return `Venció hace ${-d}d`;
  if (d === 0) return 'Vence hoy';
  if (d === 1) return 'Vence mañana';
  return `Vence en ${d}d`;
}

function calcularSiguienteFecha(fechaActual, frecuencia) {
  const d = new Date(fechaActual);
  if (frecuencia === 'diaria') d.setDate(d.getDate() + 1);
  else if (frecuencia === 'semanal') d.setDate(d.getDate() + 7);
  else if (frecuencia === 'quincenal') d.setDate(d.getDate() + 15);
  else if (frecuencia === 'mensual') d.setMonth(d.getMonth() + 1);
  return d.toISOString();
}

// ====== COMPONENTE PRINCIPAL ======
function Tareas({ rolUsuario, nombreMostrar, esCelular, onNavegar }) {
  const [tareas, setTareas] = useState(cargarTareas);
  const [usuarios] = useState(cargarUsuariosLS);
  const [tab, setTab] = useState('mis');
  const [busqueda, setBusqueda] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [modal, setModal] = useState(null);
  const [confirmando, setConfirmando] = useState(null);
  const [convertirModal, setConvertirModal] = useState(null); // {fase:'cargando'|'datos', tarea, datos?}
  const [toast, setToast] = useState(null);

  useEffect(() => { guardarTareasLS(tareas); }, [tareas]);

  const rolKey = normalizarRol(rolUsuario);
  const usuarioActual = useMemo(() => {
    const n = (nombreMostrar || '').toLowerCase().split(' ')[0];
    return usuarios.find(u => (u.nombre || '').toLowerCase().includes(n)) || usuarios[0] || { id: 1, nombre: nombreMostrar, rol: rolKey };
  }, [usuarios, nombreMostrar, rolKey]);

  const puedeAsignar = rolKey === 'direccion' || rolKey === 'administracion' || rolKey === 'supervisor';
  const puedeVerTodas = rolKey === 'direccion';

  const filtradas = useMemo(() => {
    let arr = tareas;
    if (tab === 'mis') arr = arr.filter(t => t.asignadoA === usuarioActual.id);
    else if (tab === 'asignadas') arr = arr.filter(t => t.asignadoPor === usuarioActual.id);
    if (filtroEstado !== 'todos') arr = arr.filter(t => t.estado === filtroEstado);
    if (busqueda) arr = arr.filter(t => t.titulo.toLowerCase().includes(busqueda.toLowerCase()));
    return [...arr].sort((a, b) => {
      const pa = PRIORIDAD_INFO[a.prioridad]?.peso || 0;
      const pb = PRIORIDAD_INFO[b.prioridad]?.peso || 0;
      if (pa !== pb) return pb - pa;
      return new Date(a.fechaVencimiento || 0) - new Date(b.fechaVencimiento || 0);
    });
  }, [tareas, tab, filtroEstado, busqueda, usuarioActual]);

  const crearTarea = (data) => {
    const base = {
      id: Date.now(),
      folio: siguienteFolio(tareas),
      ...data,
      asignadoPor: usuarioActual.id,
      estado: 'pendiente',
      fechaCreacion: new Date().toISOString(),
      fechaCompletada: null,
      etiquetas: [],
      notas: [],
      origen: 'manual',
      origenId: null,
    };
    let nuevas = [base, ...tareas];
    if (data.ciclica && data.frecuencia && data.fechaVencimiento) {
      let fechaAct = data.fechaVencimiento;
      for (let i = 1; i <= 3; i++) {
        fechaAct = calcularSiguienteFecha(fechaAct, data.frecuencia);
        nuevas = [
          { ...base, id: Date.now() + i, folio: `${base.folio}-${i + 1}`, fechaVencimiento: fechaAct },
          ...nuevas,
        ];
      }
    }
    setTareas(nuevas);
    setModal(null);
  };

  const cambiarEstado = (id, nuevoEstado) => {
    setTareas(prev => {
      const t = prev.find(x => x.id === id);
      if (!t) return prev;
      const actualizada = {
        ...t,
        estado: nuevoEstado,
        fechaCompletada: nuevoEstado === 'completada' ? new Date().toISOString() : t.fechaCompletada,
      };
      let arr = prev.map(x => (x.id === id ? actualizada : x));
      if (nuevoEstado === 'completada' && t.ciclica && t.frecuencia) {
        const siguiente = {
          ...t,
          id: Date.now(),
          folio: siguienteFolio(arr),
          estado: 'pendiente',
          fechaCompletada: null,
          fechaCreacion: new Date().toISOString(),
          fechaVencimiento: calcularSiguienteFecha(t.fechaVencimiento, t.frecuencia),
        };
        arr = [siguiente, ...arr];
      }
      return arr;
    });
  };

  const agregarNota = (id, texto) => {
    setTareas(prev => prev.map(t => t.id === id
      ? { ...t, notas: [...(t.notas || []), { texto, fecha: new Date().toISOString(), autor: usuarioActual.nombre }] }
      : t));
  };

  const convertirAProyecto = async (tarea) => {
    setConvertirModal({ fase: 'cargando', tarea });
    try {
      const res = await fetch(`${API_BASE}/api/clasificar-proyecto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ titulo: tarea.titulo, descripcion: tarea.descripcion }),
      });
      const datos = await res.json();
      setConvertirModal({ fase: 'datos', tarea, datos });
    } catch {
      setConvertirModal({
        fase: 'datos', tarea,
        datos: {
          tipo: 'otro', subtipo: 'general',
          requiereVisita: false, requiereCotizacion: false, requiereAnticipo: false,
          tiempoEstimado: '', personalRecomendado: 'Técnico',
          materialesBase: [], siguientePaso: '', prioridad: 'media',
        },
      });
    }
  };

  const crearProyectoDesdeTarea = (tarea, datosFinales) => {
    let proyectos = [];
    try { proyectos = JSON.parse(localStorage.getItem(KEY_PROYECTOS) || '[]'); } catch {}
    const año = new Date().getFullYear();
    const folio = `PRY-${año}-${String(proyectos.length + 1).padStart(3, '0')}`;
    const proyecto = {
      id: Date.now(),
      folio,
      titulo: datosFinales.titulo,
      tipo: datosFinales.tipo,
      subtipo: datosFinales.subtipo,
      estado: 'nuevo',
      cliente: null,
      sucursal: null,
      requiereVisita: datosFinales.requiereVisita,
      requiereCotizacion: datosFinales.requiereCotizacion,
      requiereAnticipo: datosFinales.requiereAnticipo,
      tiempoEstimado: datosFinales.tiempoEstimado,
      personalRecomendado: datosFinales.personalRecomendado,
      materialesBase: datosFinales.materialesBase,
      siguientePaso: datosFinales.siguientePaso,
      prioridad: datosFinales.prioridad,
      origen: 'tarea',
      origenId: tarea.id,
      fechaCreacion: new Date().toISOString(),
      notas: [],
      historial: [{ accion: 'creado_desde_tarea', tareaId: tarea.id, fecha: new Date().toISOString() }],
    };
    try {
      localStorage.setItem(KEY_PROYECTOS, JSON.stringify([proyecto, ...proyectos]));
      window.dispatchEvent(new Event('beep:proyectos-actualizados'));
    } catch {}
    setTareas(prev => prev.map(t => t.id === tarea.id ? { ...t, estado: 'convertida_proyecto' } : t));
    setConvertirModal(null);
    setToast(`✅ Proyecto creado: ${folio}`);
    setTimeout(() => setToast(null), 3500);
    if (onNavegar) setTimeout(() => onNavegar('operaciones.expedientes-todos'), 800);
  };

  const convertirARequerimiento = (tarea) => {
    try {
      sessionStorage.setItem('beep_req_prellenado', JSON.stringify({ titulo: tarea.titulo, descripcion: tarea.descripcion }));
    } catch {}
    if (onNavegar) onNavegar('requerimientos.nuevo');
  };

  const tarjetaCard = { background: '#fff', borderRadius: 14, padding: esCelular ? 12 : 18, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' };
  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', background: '#fff', boxSizing: 'border-box' };
  const btnPrimario = { padding: '10px 18px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontSize: 13, fontWeight: 700, cursor: 'pointer' };

  const tabs = [
    { id: 'mis', label: 'Mis tareas', visible: true },
    { id: 'asignadas', label: 'Asignadas', visible: puedeAsignar },
    { id: 'todas', label: 'Todas', visible: puedeVerTodas },
  ].filter(t => t.visible);

  return (
    <div style={{ fontFamily: PP, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: esCelular ? 20 : 24, fontWeight: 800, color: COLOR_GRIS }}>✅ Tareas</div>
          <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 4 }}>
            {filtradas.length} tareas en esta vista
          </div>
        </div>
        <button onClick={() => setModal({ modo: 'crear' })} style={btnPrimario}>+ Nueva tarea</button>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '8px 18px', borderRadius: 12,
              background: tab === t.id ? COLOR_PRINCIPAL : '#fff',
              color: tab === t.id ? '#fff' : COLOR_OSCURO,
              border: `1.5px solid ${COLOR_PRINCIPAL}`,
              fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: PP,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={tarjetaCard}>
        <input
          type="text"
          placeholder="🔍 Buscar tarea..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          style={{ ...inputBase, width: '100%', marginBottom: 10 }}
        />
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {[
            { id: 'todos', label: 'Todos' },
            { id: 'pendiente', label: 'Pendientes' },
            { id: 'en_proceso', label: 'En proceso' },
            { id: 'completada', label: 'Completadas' },
          ].map(e => (
            <button
              key={e.id}
              onClick={() => setFiltroEstado(e.id)}
              style={{
                padding: '6px 14px', borderRadius: 14,
                background: filtroEstado === e.id ? COLOR_OSCURO : '#fff',
                color: filtroEstado === e.id ? '#fff' : COLOR_OSCURO,
                border: `1.5px solid ${COLOR_OSCURO}`,
                fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
              }}
            >
              {e.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {filtradas.length === 0 ? (
          <div style={{ ...tarjetaCard, textAlign: 'center', color: COLOR_GRIS_CLARO, fontSize: 13, padding: 40 }}>
            No hay tareas en esta vista.
          </div>
        ) : filtradas.map(t => (
          <TarjetaTarea
            key={t.id}
            tarea={t}
            usuarios={usuarios}
            esCelular={esCelular}
            onAbrir={() => setModal({ modo: 'detalle', tarea: t })}
            onCambiarEstado={(estado) => {
              if (estado === 'completada') setConfirmando({ id: t.id });
              else cambiarEstado(t.id, estado);
            }}
          />
        ))}
      </div>

      {modal?.modo === 'crear' && (
        <ModalNuevaTarea
          usuarios={usuarios}
          onCrear={crearTarea}
          onCerrar={() => setModal(null)}
        />
      )}

      {modal?.modo === 'detalle' && (
        <ModalDetalle
          tarea={tareas.find(t => t.id === modal.tarea.id) || modal.tarea}
          usuarios={usuarios}
          onCerrar={() => setModal(null)}
          onCambiarEstado={(estado) => {
            if (estado === 'completada') setConfirmando({ id: modal.tarea.id });
            else cambiarEstado(modal.tarea.id, estado);
          }}
          onAgregarNota={(texto) => agregarNota(modal.tarea.id, texto)}
          onConvertirProyecto={() => { convertirAProyecto(modal.tarea); setModal(null); }}
          onConvertirRequerimiento={() => { convertirARequerimiento(modal.tarea); setModal(null); }}
        />
      )}

      {convertirModal?.fase === 'cargando' && (
        <div style={overlay}>
          <div style={{ ...modalCard, maxWidth: 360, textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>🤖</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: COLOR_OSCURO, marginBottom: 6 }}>
              Analizando tarea con IA...
            </div>
            <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>
              Clasificando proyecto y sugiriendo materiales
            </div>
          </div>
        </div>
      )}
      {convertirModal?.fase === 'datos' && (
        <ModalConvertirProyecto
          tarea={convertirModal.tarea}
          datos={convertirModal.datos}
          onCerrar={() => setConvertirModal(null)}
          onCrear={(datosFinales) => crearProyectoDesdeTarea(convertirModal.tarea, datosFinales)}
        />
      )}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
          background: '#1D9E75', color: '#fff', padding: '12px 22px',
          borderRadius: 12, fontWeight: 700, fontSize: 13, fontFamily: PP,
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)', zIndex: 2000,
        }}>
          {toast}
        </div>
      )}

      {confirmando && (
        <div style={overlay}>
          <div style={{ ...modalCard, maxWidth: 360, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: COLOR_OSCURO, marginBottom: 8 }}>
              ¿Marcar como completada?
            </div>
            <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginBottom: 16 }}>
              Esta acción no se puede deshacer.
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setConfirmando(null)} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontFamily: PP }}>
                Cancelar
              </button>
              <button
                onClick={() => { cambiarEstado(confirmando.id, 'completada'); setConfirmando(null); }}
                style={{ flex: 1, padding: 12, background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontFamily: PP }}
              >
                Sí, completar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TarjetaTarea({ tarea, usuarios, esCelular, onAbrir, onCambiarEstado }) {
  const asignado = usuarios.find(u => u.id === tarea.asignadoA);
  const prio = PRIORIDAD_INFO[tarea.prioridad] || PRIORIDAD_INFO.media;
  const estado = ESTADO_INFO[tarea.estado] || ESTADO_INFO.pendiente;
  const tipo = TIPO_INFO[tarea.tipo] || TIPO_INFO.normal;
  const colorVenc = colorVencimiento(tarea.fechaVencimiento);

  return (
    <div
      onClick={onAbrir}
      style={{
        background: '#fff', borderRadius: 12,
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        display: 'flex', overflow: 'hidden', cursor: 'pointer',
      }}
    >
      <div style={{ width: 6, background: prio.color, flexShrink: 0 }} />
      <div style={{ flex: 1, padding: esCelular ? 12 : 14, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 600 }}>{tarea.folio}</div>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: 10, fontWeight: 700, background: '#eef0f3', color: COLOR_GRIS, padding: '2px 8px', borderRadius: 10 }}>
              {tipo.icono} {tipo.label}
            </span>
            <span style={{ fontSize: 10, fontWeight: 700, background: estado.bg, color: estado.color, padding: '2px 8px', borderRadius: 10 }}>
              {estado.label}
            </span>
          </div>
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_GRIS, marginBottom: 4 }}>
          {tarea.titulo}
        </div>
        {tarea.descripcion && (
          <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {tarea.descripcion}
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          {asignado && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{
                width: 24, height: 24, borderRadius: '50%',
                background: ROL_INFO[asignado.rol]?.color || COLOR_PRINCIPAL,
                color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, fontWeight: 700,
              }}>
                {iniciales(asignado.nombre)}
              </div>
              <span style={{ fontSize: 12, color: COLOR_GRIS }}>{asignado.nombre.split(' ')[0]}</span>
            </div>
          )}
          <span style={{ fontSize: 11, fontWeight: 700, color: colorVenc }}>
            🕐 {textoVencimiento(tarea.fechaVencimiento)}
          </span>
          {tarea.estado !== 'completada' && tarea.estado !== 'cancelada' && (
            <button
              onClick={(e) => { e.stopPropagation(); onCambiarEstado(tarea.estado === 'pendiente' ? 'en_proceso' : 'completada'); }}
              style={{
                marginLeft: 'auto',
                background: tarea.estado === 'pendiente' ? COLOR_PRINCIPAL : '#1D9E75',
                color: '#fff', border: 'none', borderRadius: 8,
                padding: '6px 12px', fontSize: 11, fontWeight: 700,
                cursor: 'pointer', fontFamily: PP,
              }}
            >
              {tarea.estado === 'pendiente' ? 'Iniciar' : 'Completar'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// Valores con los que ABRE el formulario. Sirven para saber si de verdad hay algo capturado
// (sin esto, los selectores con default harian creer que siempre hay cambios sin guardar).
const INICIAL_TAREA = { titulo: '', descripcion: '', tipo: 'normal', prioridad: 'media', asignadoA: '',
  fechaVencimiento: '', hora: '', frecuencia: 'semanal', diaSemana: 'lunes', diaMes: 1 };

function ModalNuevaTarea({ usuarios, onCrear, onCerrar }) {
  // TANDA 2 (2026-09-14): red de seguridad. Lo capturado se guarda mientras se escribe y se ofrece
  // rescatarlo al reabrir; cerrar con algo escrito pregunta en vez de descartar en silencio.
  const [paso, setPaso] = useState(1);
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [tipo, setTipo] = useState('normal');
  const [prioridad, setPrioridad] = useState('media');
  const [asignadoA, setAsignadoA] = useState('');
  const [busquedaUsuario, setBusquedaUsuario] = useState('');
  const [fechaVencimiento, setFechaVencimiento] = useState('');
  const [hora, setHora] = useState('');
  const [frecuencia, setFrecuencia] = useState('semanal');
  const [diaSemana, setDiaSemana] = useState('lunes');
  const [diaMes, setDiaMes] = useState(1);
  const [notificarA, setNotificarA] = useState([]);

  const camposBorrador = { titulo, descripcion, tipo, prioridad, asignadoA, fechaVencimiento, hora, frecuencia, diaSemana, diaMes };
  const aplicarBorrador = (d) => {
    if (d.titulo != null) setTitulo(d.titulo);
    if (d.descripcion != null) setDescripcion(d.descripcion);
    if (d.tipo != null) setTipo(d.tipo);
    if (d.prioridad != null) setPrioridad(d.prioridad);
    if (d.asignadoA != null) setAsignadoA(d.asignadoA);
    if (d.fechaVencimiento != null) setFechaVencimiento(d.fechaVencimiento);
    if (d.hora != null) setHora(d.hora);
    if (d.frecuencia != null) setFrecuencia(d.frecuencia);
    if (d.diaSemana != null) setDiaSemana(d.diaSemana);
    if (d.diaMes != null) setDiaMes(d.diaMes);
  };
  const bor = useBorradorCampos('tareas', 'nueva', camposBorrador, aplicarBorrador, { iniciales: INICIAL_TAREA });

  const usuariosFiltrados = busquedaUsuario
    ? usuarios.filter(u => u.nombre.toLowerCase().includes(busquedaUsuario.toLowerCase()))
    : usuarios;
  const asignado = usuarios.find(u => u.id === asignadoA);

  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 600, marginBottom: 4, display: 'block' };

  const puedeAvanzar1 = titulo.trim().length > 0;
  const puedeAvanzar2 = asignadoA && fechaVencimiento;

  const submit = () => {
    onCrear({
      titulo: titulo.trim(),
      descripcion: descripcion.trim(),
      tipo, prioridad,
      asignadoA, rol: asignado?.rol || '',
      fechaVencimiento: fechaVencimiento ? new Date(fechaVencimiento).toISOString() : null,
      hora: hora || null,
      ciclica: tipo === 'ciclica',
      frecuencia: tipo === 'ciclica' ? frecuencia : null,
      diaSemana: tipo === 'ciclica' && frecuencia === 'semanal' ? diaSemana : null,
      diaMes: tipo === 'ciclica' && frecuencia === 'mensual' ? diaMes : null,
      notificarA,
    });
    bor.limpiar(); // creada en el servidor: el borrador ya no hace falta
  };

  const toggleNotif = (id) => {
    setNotificarA(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  return (
    <div style={overlay}>
      <div style={{ ...modalCard, maxWidth: 520 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: COLOR_OSCURO }}>Nueva tarea</div>
          <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>Paso {paso} de 3</div>
        </div>

        <div style={{ display: 'flex', gap: 4, marginBottom: 18 }}>
          {[1, 2, 3].map(n => (
            <div key={n} style={{ flex: 1, height: 4, borderRadius: 4, background: n <= paso ? COLOR_PRINCIPAL : '#e6e9ee' }} />
          ))}
        </div>

        <AvisoRescate bor={bor} />

        {paso === 1 && (
          <div>
            <label style={labelStyle}>Título *</label>
            <input value={titulo} onChange={(e) => setTitulo(e.target.value)} style={inputBase} placeholder="Ej: Entregar reporte semanal" />

            <label style={{ ...labelStyle, marginTop: 12 }}>Descripción</label>
            <textarea
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              rows={3}
              style={{ ...inputBase, fontFamily: PP, resize: 'vertical' }}
              placeholder="Detalles..."
            />

            <label style={{ ...labelStyle, marginTop: 12 }}>Tipo</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {Object.entries(TIPO_INFO).map(([k, info]) => (
                <button
                  key={k}
                  onClick={() => setTipo(k)}
                  style={{
                    flex: '1 1 45%', padding: '10px', borderRadius: 10,
                    background: tipo === k ? COLOR_PRINCIPAL : '#fff',
                    color: tipo === k ? '#fff' : COLOR_OSCURO,
                    border: `1.5px solid ${COLOR_PRINCIPAL}`,
                    fontWeight: 600, fontSize: 12, cursor: 'pointer', fontFamily: PP,
                  }}
                >
                  {info.icono} {info.label}
                </button>
              ))}
            </div>

            <label style={{ ...labelStyle, marginTop: 12 }}>Prioridad</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {Object.entries(PRIORIDAD_INFO).map(([k, info]) => (
                <button
                  key={k}
                  onClick={() => setPrioridad(k)}
                  style={{
                    flex: 1, padding: '10px', borderRadius: 10,
                    background: prioridad === k ? info.color : '#fff',
                    color: prioridad === k ? '#fff' : COLOR_GRIS,
                    border: `1.5px solid ${info.color}`,
                    fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: PP,
                  }}
                >
                  {info.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {paso === 2 && (
          <div>
            <label style={labelStyle}>Asignar a *</label>
            <input
              type="text"
              placeholder="Buscar usuario..."
              value={asignado ? asignado.nombre : busquedaUsuario}
              onChange={(e) => { setAsignadoA(''); setBusquedaUsuario(e.target.value); }}
              style={inputBase}
            />
            {!asignado && (
              <div style={{ marginTop: 4, maxHeight: 160, overflowY: 'auto', border: '1px solid #e6e9ee', borderRadius: 10 }}>
                {usuariosFiltrados.map(u => (
                  <div
                    key={u.id}
                    onClick={() => { setAsignadoA(u.id); setBusquedaUsuario(''); }}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 10, cursor: 'pointer', borderBottom: '1px solid #f0f2f5' }}
                  >
                    <div style={{
                      width: 32, height: 32, borderRadius: '50%',
                      background: ROL_INFO[u.rol]?.color || COLOR_PRINCIPAL,
                      color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 11, fontWeight: 700,
                    }}>{iniciales(u.nombre)}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: COLOR_GRIS }}>{u.nombre}</div>
                      <div style={{ fontSize: 10, color: COLOR_GRIS_CLARO }}>{ROL_INFO[u.rol]?.label}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <label style={{ ...labelStyle, marginTop: 12 }}>Fecha límite *</label>
            <input type="date" value={fechaVencimiento} onChange={(e) => setFechaVencimiento(e.target.value)} style={inputBase} />

            <label style={{ ...labelStyle, marginTop: 12 }}>Hora</label>
            <input type="time" value={hora} onChange={(e) => setHora(e.target.value)} style={inputBase} />

            {tipo === 'ciclica' && (
              <div style={{ marginTop: 14, padding: 12, background: '#eaf2fb', borderRadius: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 8 }}>🔄 Frecuencia</div>
                <select value={frecuencia} onChange={(e) => setFrecuencia(e.target.value)} style={inputBase}>
                  <option value="diaria">Diaria</option>
                  <option value="semanal">Semanal</option>
                  <option value="quincenal">Quincenal</option>
                  <option value="mensual">Mensual</option>
                </select>
                {frecuencia === 'semanal' && (
                  <select value={diaSemana} onChange={(e) => setDiaSemana(e.target.value)} style={{ ...inputBase, marginTop: 6 }}>
                    {DIAS_SEMANA.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                )}
                {frecuencia === 'mensual' && (
                  <input
                    type="number" min="1" max="31"
                    value={diaMes}
                    onChange={(e) => setDiaMes(Number(e.target.value))}
                    style={{ ...inputBase, marginTop: 6 }}
                    placeholder="Día del mes (1-31)"
                  />
                )}
              </div>
            )}

            <label style={{ ...labelStyle, marginTop: 12 }}>Notificar a (si no se completa)</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {usuarios.map(u => (
                <button
                  key={u.id}
                  onClick={() => toggleNotif(u.id)}
                  style={{
                    padding: '6px 10px', borderRadius: 14,
                    background: notificarA.includes(u.id) ? COLOR_PRINCIPAL : '#fff',
                    color: notificarA.includes(u.id) ? '#fff' : COLOR_OSCURO,
                    border: `1.5px solid ${COLOR_PRINCIPAL}`,
                    fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
                  }}
                >
                  {u.nombre.split(' ')[0]}
                </button>
              ))}
            </div>
          </div>
        )}

        {paso === 3 && (
          <div style={{ background: COLOR_FONDO, borderRadius: 12, padding: 16 }}>
            <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, fontWeight: 700, marginBottom: 6 }}>RESUMEN</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: COLOR_OSCURO, marginBottom: 4 }}>{titulo}</div>
            {descripcion && <div style={{ fontSize: 12, color: COLOR_GRIS, marginBottom: 8 }}>{descripcion}</div>}
            <div style={{ fontSize: 12, color: COLOR_GRIS, lineHeight: 1.8 }}>
              <div><strong>Tipo:</strong> {TIPO_INFO[tipo].icono} {TIPO_INFO[tipo].label}</div>
              <div><strong>Prioridad:</strong> <span style={{ color: PRIORIDAD_INFO[prioridad].color, fontWeight: 700 }}>{PRIORIDAD_INFO[prioridad].label}</span></div>
              <div><strong>Asignada a:</strong> {asignado?.nombre || '—'}</div>
              <div><strong>Vence:</strong> {fechaVencimiento || '—'} {hora && `a las ${hora}`}</div>
              {tipo === 'ciclica' && (
                <div><strong>Frecuencia:</strong> {frecuencia}{frecuencia === 'semanal' ? ` (${diaSemana})` : ''}{frecuencia === 'mensual' ? ` (día ${diaMes})` : ''}</div>
              )}
              {notificarA.length > 0 && (
                <div><strong>Notifica a:</strong> {notificarA.length} usuario(s)</div>
              )}
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          {paso > 1 && (
            <button onClick={() => setPaso(paso - 1)} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
              Atrás
            </button>
          )}
          <button onClick={bor.confirmarCierre(onCerrar)} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
            Cancelar
          </button>
          {paso < 3 ? (
            <button
              onClick={() => setPaso(paso + 1)}
              disabled={paso === 1 ? !puedeAvanzar1 : !puedeAvanzar2}
              style={{
                flex: 1, padding: 12, background: COLOR_PRINCIPAL, color: '#fff',
                border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700,
                cursor: 'pointer',
                opacity: (paso === 1 ? puedeAvanzar1 : puedeAvanzar2) ? 1 : 0.5,
              }}
            >
              Siguiente →
            </button>
          ) : (
            <button onClick={submit} style={{ flex: 1, padding: 12, background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
              Crear tarea
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function ModalDetalle({ tarea, usuarios, onCerrar, onCambiarEstado, onAgregarNota, onConvertirProyecto, onConvertirRequerimiento }) {
  const [nuevaNota, setNuevaNota] = useState('');
  const asignado = usuarios.find(u => u.id === tarea.asignadoA);
  const asignador = usuarios.find(u => u.id === tarea.asignadoPor);
  const prio = PRIORIDAD_INFO[tarea.prioridad] || PRIORIDAD_INFO.media;
  const estado = ESTADO_INFO[tarea.estado] || ESTADO_INFO.pendiente;
  const tipo = TIPO_INFO[tarea.tipo] || TIPO_INFO.normal;

  const btn = (bg, color = '#fff') => ({
    padding: '10px 14px', background: bg, color, border: 'none',
    borderRadius: 10, fontFamily: PP, fontWeight: 700, fontSize: 12, cursor: 'pointer', flex: 1,
  });

  return (
    <div style={overlay}>
      <div style={{ ...modalCard, maxWidth: 520 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 600 }}>{tarea.folio}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: COLOR_OSCURO, marginTop: 2 }}>{tarea.titulo}</div>
          </div>
          <button onClick={onCerrar} style={{ background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', color: COLOR_GRIS_CLARO, lineHeight: 1 }}>×</button>
        </div>

        <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 11, fontWeight: 700, background: prio.color + '22', color: prio.color, padding: '4px 10px', borderRadius: 12 }}>
            {prio.label}
          </span>
          <span style={{ fontSize: 11, fontWeight: 700, background: estado.bg, color: estado.color, padding: '4px 10px', borderRadius: 12 }}>
            {estado.label}
          </span>
          <span style={{ fontSize: 11, fontWeight: 700, background: '#eef0f3', color: COLOR_GRIS, padding: '4px 10px', borderRadius: 12 }}>
            {tipo.icono} {tipo.label}
          </span>
        </div>

        {tarea.descripcion && (
          <div style={{ fontSize: 13, color: COLOR_GRIS, marginBottom: 12, lineHeight: 1.5 }}>
            {tarea.descripcion}
          </div>
        )}

        <div style={{ background: COLOR_FONDO, borderRadius: 10, padding: 12, marginBottom: 12, fontSize: 12, color: COLOR_GRIS, lineHeight: 1.8 }}>
          <div><strong>Asignada a:</strong> {asignado?.nombre || '—'}</div>
          <div><strong>Asignada por:</strong> {asignador?.nombre || '—'}</div>
          <div><strong>Vence:</strong> <span style={{ color: colorVencimiento(tarea.fechaVencimiento), fontWeight: 700 }}>{textoVencimiento(tarea.fechaVencimiento)}</span> ({fechaCorta(tarea.fechaVencimiento)}{tarea.hora ? ` · ${tarea.hora}` : ''})</div>
          {tarea.ciclica && <div><strong>Frecuencia:</strong> {tarea.frecuencia}{tarea.diaSemana ? ` (${tarea.diaSemana})` : ''}</div>}
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, fontWeight: 700, marginBottom: 6 }}>NOTAS / HISTORIAL</div>
          {(tarea.notas || []).length === 0 ? (
            <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, fontStyle: 'italic' }}>Sin notas todavía</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 140, overflowY: 'auto' }}>
              {tarea.notas.map((n, i) => (
                <div key={i} style={{ background: '#eaf2fb', borderRadius: 8, padding: 8, fontSize: 12, color: COLOR_GRIS }}>
                  <div>{n.texto}</div>
                  <div style={{ fontSize: 10, color: COLOR_GRIS_CLARO, marginTop: 2 }}>{n.autor} · {fechaCorta(n.fecha)}</div>
                </div>
              ))}
            </div>
          )}
          <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
            <input
              type="text"
              placeholder="Agregar nota..."
              value={nuevaNota}
              onChange={(e) => setNuevaNota(e.target.value)}
              style={{ flex: 1, padding: '8px 10px', borderRadius: 8, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 12 }}
            />
            <button
              onClick={() => { if (nuevaNota.trim()) { onAgregarNota(nuevaNota.trim()); setNuevaNota(''); } }}
              style={{ padding: '8px 14px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontFamily: PP, fontSize: 12 }}
            >
              +
            </button>
          </div>
        </div>

        {tarea.estado !== 'completada' && tarea.estado !== 'cancelada' && (
          <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
            {tarea.estado === 'pendiente' && (
              <button onClick={() => onCambiarEstado('en_proceso')} style={btn(COLOR_PRINCIPAL)}>▶ En proceso</button>
            )}
            <button onClick={() => onCambiarEstado('completada')} style={btn('#1D9E75')}>✓ Completar</button>
          </div>
        )}
        <div style={{ display: 'flex', gap: 6 }}>
          <button onClick={onConvertirProyecto} style={{ ...btn('#fff', COLOR_OSCURO), border: `1.5px solid ${COLOR_PRINCIPAL}55` }}>📁 A proyecto</button>
          <button onClick={onConvertirRequerimiento} style={{ ...btn('#fff', COLOR_OSCURO), border: `1.5px solid ${COLOR_PRINCIPAL}55` }}>📋 A requerimiento</button>
        </div>
      </div>
    </div>
  );
}

function ModalConvertirProyecto({ tarea, datos, onCerrar, onCrear }) {
  const [titulo, setTitulo] = useState(tarea.titulo);
  const [tipo, setTipo] = useState(datos.tipo || 'otro');
  const [subtipo, setSubtipo] = useState(datos.subtipo || 'general');
  const [requiereVisita, setRequiereVisita] = useState(!!datos.requiereVisita);
  const [requiereCotizacion, setRequiereCotizacion] = useState(!!datos.requiereCotizacion);
  const [requiereAnticipo, setRequiereAnticipo] = useState(!!datos.requiereAnticipo);
  const [tiempoEstimado, setTiempoEstimado] = useState(datos.tiempoEstimado || '');
  const [personalRecomendado, setPersonalRecomendado] = useState(datos.personalRecomendado || 'Técnico');
  const [materiales, setMateriales] = useState(datos.materialesBase || []);
  const [nuevoMaterial, setNuevoMaterial] = useState('');
  const [siguientePaso, setSiguientePaso] = useState(datos.siguientePaso || '');
  const [prioridad, setPrioridad] = useState(datos.prioridad || 'media');

  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700, marginBottom: 4, display: 'block', textTransform: 'uppercase' };

  const submit = () => {
    if (!titulo.trim()) return;
    onCrear({
      titulo: titulo.trim(),
      tipo, subtipo,
      requiereVisita, requiereCotizacion, requiereAnticipo,
      tiempoEstimado, personalRecomendado,
      materialesBase: materiales,
      siguientePaso, prioridad,
    });
  };

  return (
    <div style={overlay}>
      <div style={{ ...modalCard, maxWidth: 560 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
          <div>
            <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700 }}>🤖 ANÁLISIS IA</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: COLOR_OSCURO, marginTop: 2 }}>Crear proyecto desde tarea</div>
          </div>
          <button onClick={onCerrar} style={{ background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', color: COLOR_GRIS_CLARO, lineHeight: 1 }}>×</button>
        </div>

        <label style={labelStyle}>Título del proyecto</label>
        <input value={titulo} onChange={(e) => setTitulo(e.target.value)} style={inputBase} />

        <label style={{ ...labelStyle, marginTop: 12 }}>Tipo</label>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {Object.entries(TIPO_PROYECTO_INFO).map(([k, info]) => (
            <button
              key={k}
              onClick={() => setTipo(k)}
              style={{
                padding: '8px 12px', borderRadius: 10,
                background: tipo === k ? COLOR_PRINCIPAL : '#fff',
                color: tipo === k ? '#fff' : COLOR_OSCURO,
                border: `1.5px solid ${COLOR_PRINCIPAL}`,
                fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
              }}
            >
              {info.icono} {info.label}
            </button>
          ))}
        </div>

        <label style={{ ...labelStyle, marginTop: 12 }}>Subtipo</label>
        <select value={subtipo} onChange={(e) => setSubtipo(e.target.value)} style={inputBase}>
          {SUBTIPOS.map(s => <option key={s} value={s}>{s.replace('_', ' ').toUpperCase()}</option>)}
        </select>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 12, padding: 10, background: COLOR_FONDO, borderRadius: 10 }}>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, color: COLOR_GRIS, cursor: 'pointer' }}>
            <input type="checkbox" checked={requiereVisita} onChange={(e) => setRequiereVisita(e.target.checked)} />
            Requiere visita
          </label>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, color: COLOR_GRIS, cursor: 'pointer' }}>
            <input type="checkbox" checked={requiereCotizacion} onChange={(e) => setRequiereCotizacion(e.target.checked)} />
            Requiere cotización
          </label>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, color: COLOR_GRIS, cursor: 'pointer' }}>
            <input type="checkbox" checked={requiereAnticipo} onChange={(e) => setRequiereAnticipo(e.target.checked)} />
            Requiere anticipo
          </label>
        </div>

        <label style={{ ...labelStyle, marginTop: 12 }}>Tiempo estimado</label>
        <input value={tiempoEstimado} onChange={(e) => setTiempoEstimado(e.target.value)} style={inputBase} placeholder="Ej: 3-5 días" />

        <label style={{ ...labelStyle, marginTop: 12 }}>Personal recomendado</label>
        <select value={personalRecomendado} onChange={(e) => setPersonalRecomendado(e.target.value)} style={inputBase}>
          <option>Técnico</option>
          <option>Técnico + Supervisor</option>
          <option>Cuadrilla completa</option>
        </select>

        <label style={{ ...labelStyle, marginTop: 12 }}>Materiales base</label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {materiales.map((m, i) => (
            <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'center', background: '#eaf2fb', padding: '6px 10px', borderRadius: 8 }}>
              <span style={{ flex: 1, fontSize: 12, color: COLOR_GRIS }}>{m}</span>
              <button
                onClick={() => setMateriales(materiales.filter((_, j) => j !== i))}
                style={{ background: 'transparent', border: 'none', color: COLOR_ALTA, cursor: 'pointer', fontSize: 16 }}
              >×</button>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 6 }}>
            <input
              value={nuevoMaterial}
              onChange={(e) => setNuevoMaterial(e.target.value)}
              placeholder="Agregar material..."
              style={{ ...inputBase, flex: 1 }}
            />
            <button
              onClick={() => { if (nuevoMaterial.trim()) { setMateriales([...materiales, nuevoMaterial.trim()]); setNuevoMaterial(''); } }}
              style={{ padding: '0 14px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontFamily: PP }}
            >+</button>
          </div>
        </div>

        <label style={{ ...labelStyle, marginTop: 12 }}>Siguiente paso sugerido</label>
        <textarea value={siguientePaso} onChange={(e) => setSiguientePaso(e.target.value)} rows={2} style={{ ...inputBase, fontFamily: PP, resize: 'vertical' }} />

        <label style={{ ...labelStyle, marginTop: 12 }}>Prioridad</label>
        <div style={{ display: 'flex', gap: 6 }}>
          {Object.entries(PRIORIDAD_INFO).map(([k, info]) => (
            <button
              key={k}
              onClick={() => setPrioridad(k)}
              style={{
                flex: 1, padding: 10, borderRadius: 10,
                background: prioridad === k ? info.color : '#fff',
                color: prioridad === k ? '#fff' : COLOR_GRIS,
                border: `1.5px solid ${info.color}`,
                fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: PP,
              }}
            >
              {info.label}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          <button onClick={onCerrar} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
            Cancelar
          </button>
          <button onClick={submit} style={{ flex: 2, padding: 12, background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
            ✓ Crear proyecto
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(20,30,50,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000, padding: 16,
};
const modalCard = {
  background: '#fff', borderRadius: 16, padding: 22,
  width: '100%', maxHeight: 'calc(var(--beep-vh) * 90)', overflowY: 'auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.25)', fontFamily: PP,
};

export default Tareas;
